import axios from "axios";
import { IBooking } from "../../types";

interface IExecBookingActionParams {
    bookingId: string,
    action: string,
    subaction?: string,
    note?: string,
    lastUpdateTime: string | null,
    assignedPlateNumber?: string | null,
    pendingAction?: string | null
}

interface IExecBookingActionReturn {
    booking: IBooking
}

export const execBookingAction = async ({ bookingId, ...params }: IExecBookingActionParams): Promise<IExecBookingActionReturn> => {
    const response = await axios.post(`/booking/book/${bookingId}/action`, params);
    return response.data;
};

export default execBookingAction;